export default "__VITE_ASSET__536ad677__"